module.exports = __webpack_public_path__ + "img/3.d883506d.png";